import { Tags, type DeviceParameterConfig } from '@eppendorf/app-configs';
import { Icon, IconSizeClasses, Badge } from '@eppendorf/vnls-react-components';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { getIconNameForParameterName } from '$features/monitoring/monitoring.utils';

import styles from './monitoring-parameter-offline.module.scss';

export interface MonitoringParameterOfflineProps {
  name?: string;
  parameterConfig?: DeviceParameterConfig | undefined;
}

export function MonitoringParameterOffline({
  name,
  parameterConfig,
}: MonitoringParameterOfflineProps) {
  const { t } = useTranslation();

  return (
    <div className={cn(`box`, styles.monitoringParameterBoxOfflineHead)} role="button">
      <div className={styles.monitoringParameterOfflineHeadline}>
        <Icon
          name={getIconNameForParameterName(name)}
          size={IconSizeClasses.Responsive}
          className={cn(styles.monitoringParameterOfflineHeadlineIcon, 'ic_parameters')} // fallback if parameter doesn't have an icon yet
        />
        <span className={styles.monitoringParameterOfflineValue}>{name}</span>
        {parameterConfig?.tags?.includes(Tags.Extension) && (
          <Icon name="sense-sensor" size={IconSizeClasses.XSmall} />
        )}
      </div>
      <Badge size="small" className={styles.monitoringParameterOfflineBadge}>
        {t('monitoringDetail.noLiveData')}
      </Badge>
    </div>
  );
}
